import { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const SESSION_DURATION = 14 * 60  // 14 minutes in seconds
const WARN_AT = 2 * 60
const DANGER_AT = 30
const STORAGE_KEY = 'session_end_time'

function getInitialTimeLeft() {
  const endTime = sessionStorage.getItem(STORAGE_KEY)
  if (!endTime) return SESSION_DURATION
  const remaining = Math.floor((parseInt(endTime) - Date.now()) / 1000)
  return remaining > 0 ? remaining : 0
}

function setNewSession() {
  const endTime = Date.now() + SESSION_DURATION * 1000
  sessionStorage.setItem(STORAGE_KEY, endTime.toString())
  return SESSION_DURATION
}

export function useSession() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const remaining = getInitialTimeLeft()
    // જો session storage માં valid time નથી તો નવો set કરો
    if (!sessionStorage.getItem(STORAGE_KEY) || remaining <= 0) {
      setNewSession()
      return remaining <= 0 ? 0 : SESSION_DURATION
    }
    return remaining
  })

  const timerRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()

  // Tab change → session restart
  const resetSession = useCallback(() => {
    setNewSession()
    setTimeLeft(SESSION_DURATION)
  }, [])

  useEffect(() => {
    resetSession()
  }, [location.pathname])

  // Countdown — sessionStorage end_time પ્રમાણે calculate કરે
  useEffect(() => {
    if (timeLeft <= 0) {
      sessionStorage.removeItem(STORAGE_KEY)
      navigate('/')
      return
    }

    clearInterval(timerRef.current)
    timerRef.current = setInterval(() => {
      const endTime = sessionStorage.getItem(STORAGE_KEY)
      if (!endTime) {
        clearInterval(timerRef.current)
        navigate('/')
        return
      }
      const remaining = Math.floor((parseInt(endTime) - Date.now()) / 1000)
      if (remaining <= 0) {
        clearInterval(timerRef.current)
        sessionStorage.removeItem(STORAGE_KEY)
        setTimeLeft(0)
        navigate('/')
      } else {
        setTimeLeft(remaining)
      }
    }, 1000)

    return () => clearInterval(timerRef.current)
  }, [navigate, timeLeft <= 0])

  const fmt = (s) =>
    String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0')

  return {
    timeStr: fmt(timeLeft),
    pct: Math.round((timeLeft / SESSION_DURATION) * 100),
    isWarn: timeLeft <= WARN_AT && timeLeft > 0,
    isDanger: timeLeft <= DANGER_AT && timeLeft > 0,
    isExpired: timeLeft === 0,
    resetSession,
    timeLeft,
  }
}